import { MAGAZINE_EDIT_WRAPPER } from 'js/magazine/AddEdit/Edit/Edit.queries'
import { MAGAZINES_LIST } from 'js/magazine/List/components/MagazineList.queries'
import { MAGAZINE_VIEW } from 'js/magazine/View/View.queries'

export default [MAGAZINE_VIEW, MAGAZINES_LIST, MAGAZINE_EDIT_WRAPPER]
